var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('base-page-layout',{attrs:{"title":_vm.pageTitle}},[_c('busca-component',{attrs:{"search-type":_vm.searchType}}),(_vm.searchType === 'cliente')?_c('export-clients-hotsite'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }